import React, { useEffect, useState } from "react";
import "./registration.scss";

import SnackBar from "../../components/snackbar/Snackbar";

import Step1 from "./components/step1/Step1";
import Step2 from "./components/step2/Step2";
import Step3 from "./components/step3/Step3";
import Step4 from "./components/step4/Step4";
import StepAssociation1 from "./components/stepAssociation1/StepAssociation1";
import StepAssociation2 from "./components/stepAssociation2/StepAssociation2";
import StepAssociation3 from "./components/stepAssociation3/StepAssociation3";

import { registrationWS } from "./api/registrationApi";
import { gestioneSnackbar } from "../../utils/common";
import { useLocation, useNavigate } from "react-router-dom";
import { daProvinciaASigla } from "../../enums/province";

const Registration = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tel, setTel] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [nameAssociation, setNameAssociation] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [comune, setComune] = useState("");
  const [provincia, setProvincia] = useState("");
  const [dateOfFoundation, setDateOfFoundation] = useState("");
  const [description, setDescription] = useState("");
  const [selectedEventType, setSelectedEventType] = useState([]);
  const [selectedAssociations, setSelectedAssociations] = useState([]);
  const [selectedAssociationTopic, setSelectedAssociationTopic] = useState([]);
  const [activationCode, setActivationCode] = useState("");

  useEffect(() => {
    const id_association = queryParams.get("id_association");

    if (id_association) setSelectedAssociations([id_association]);
  }, [location.search]);

  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step > 1 ? step - 1 : 1);
  };

  const handleRegistration = () => {
    registrationWS({
      name,
      surname,
      email,
      password,
      tel,
      birthDate,
      selectedEventType,
      admin,
      activationCode,
      nameAssociation,
      description,
      address: indirizzo + ", " + comune + ", " + daProvinciaASigla[provincia],
      dateOfFoundation,
      selectedAssociationTopic,
      selectedAssociations,
    })
      .then((res) => {
        //gestioneSnackbar(true, res.message, "success");
        navigate("/send-mail-confirm-registration/");
      })
      .catch((err) => {
        return gestioneSnackbar(true, err, "error");
      });
  };

  return (
    <div className="registration d-flex min-vh-100">
      {step === 1 ? (
        <Step1
          name={name}
          setName={setName}
          surname={surname}
          setSurname={setSurname}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          nextStep={nextStep}
        />
      ) : null}
      {step === 2 ? (
        <Step2
          birthDate={birthDate}
          setBirthDate={setBirthDate}
          tel={tel}
          setTel={setTel}
          privacyPolicy={privacyPolicy}
          setPrivacyPolicy={setPrivacyPolicy}
          terms={terms}
          setTerms={setTerms}
          nextStep={nextStep}
          previousStep={previousStep}
        />
      ) : null}
      {step === 3 ? (
        <Step3
          admin={admin}
          setAdmin={setAdmin}
          nextStep={nextStep}
          previousStep={previousStep}
        />
      ) : null}
      {admin ? (
        /*PARTE INSERIMENTO DATI ASSOCIAZIONE*/
        <>
          {step === 4 ? (
            <StepAssociation1
              activationCode={activationCode}
              setActivationCode={setActivationCode}
              nextStep={nextStep}
              previousStep={previousStep}
            />
          ) : null}
          {step === 5 ? (
            <StepAssociation2
              nameAssociation={nameAssociation}
              setNameAssociation={setNameAssociation}
              indirizzo={indirizzo}
              setIndirizzo={setIndirizzo}
              comune={comune}
              setComune={setComune}
              provincia={provincia}
              setProvincia={setProvincia}
              dateOfFoundation={dateOfFoundation}
              setDateOfFoundation={setDateOfFoundation}
              description={description}
              setDescription={setDescription}
              nextStep={nextStep}
              previousStep={previousStep}
            />
          ) : null}
          {step === 6 ? (
            <StepAssociation3
              selectedAssociationTopic={selectedAssociationTopic}
              setSelectedAssociationTopic={setSelectedAssociationTopic}
              nextStep={nextStep}
              previousStep={previousStep}
            />
          ) : null}
          {step === 7 ? (
            <Step4
              selectedEventType={selectedEventType}
              setSelectedEventType={setSelectedEventType}
              admin={true}
              nextStep={nextStep}
              previousStep={previousStep}
              handleRegistration={handleRegistration}
            />
          ) : null}
        </>
      ) : (
        /*PARTE INSERIMENTO DATI VOLONTARIO*/
        <>
          {step === 4 ? (
            <Step4
              selectedEventType={selectedEventType}
              setSelectedEventType={setSelectedEventType}
              selectedAssociations={selectedAssociations}
              setSelectedAssociations={setSelectedAssociations}
              admin={admin}
              nextStep={nextStep}
              previousStep={previousStep}
              handleRegistration={handleRegistration}
            />
          ) : null}
        </>
      )}
      <SnackBar />
    </div>
  );
};

export default Registration;
